import CalendarIcon from "@mui/icons-material/CalendarTodayRounded";
import RenameIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import PersonIcon from "@mui/icons-material/PersonOutlineRounded";
import TitleIcon from "@mui/icons-material/TitleRounded";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import ShowMoreLessButton from "@entrilia/shared/components/ShowMoreLessButton";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import useToggleState from "@entrilia/shared/hooks/useToggleState";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import FundraisingAttributeLine from "./FundraisingAttributeLine";
import useFundraisingDetailsPageContext from "./useFundraisingDetailsPageContext";

const FundraisingDetailsSection = () => {
  const { fundraising, hasEditPermissions, onRename } = useFundraisingDetailsPageContext();

  const [expanded, toggleExpanded] = useToggleState(false);

  return (
    <Stack sx={{ width: "100%" }}>
      <Typography variant="subtitle1" sx={{ pt: 2, pb: 1 }}>
        Details
      </Typography>
      <FundraisingAttributeLine Icon={TitleIcon} label="Name">
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography noWrap>{fundraising.name}</Typography>
          {hasEditPermissions && (
            <IconButton onClick={onRename}>
              <RenameIcon />
            </IconButton>
          )}
        </Stack>
      </FundraisingAttributeLine>
      <FundraisingAttributeLine Icon={PersonIcon} label="Created by">
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <UserAvatar userName={fundraising.createdByUserName} size="small" />
          <Typography noWrap>{fundraising.createdByUserName}</Typography>
        </Stack>
      </FundraisingAttributeLine>
      {expanded && (
        <>
          <FundraisingAttributeLine Icon={CalendarIcon} label="Created at">
            <Typography>{convertISODateTime(fundraising.createdAt)}</Typography>
          </FundraisingAttributeLine>

          <FundraisingAttributeLine Icon={PersonIcon} label="Modified by">
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <UserAvatar userName={fundraising.updatedByUserName} size="small" />
              <Typography noWrap>{fundraising.updatedByUserName}</Typography>
            </Stack>
          </FundraisingAttributeLine>

          <FundraisingAttributeLine Icon={CalendarIcon} label="Modified at">
            <Typography>{convertISODateTime(fundraising.updatedAt)}</Typography>
          </FundraisingAttributeLine>
        </>
      )}
      <Box sx={{ py: 1 }}>
        <ShowMoreLessButton expanded={expanded} onClick={toggleExpanded} />
      </Box>
    </Stack>
  );
};

export default FundraisingDetailsSection;
